import React from "react";
import {
  Box,
  Typography,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ColoredAvatar from "./hooks/colorAvatar";

const SecretDetailsCard = ({
  name,
  avatarInitials,
  timeAgo,
  clusterName,
  env,
  createdBy,
  secretName,
  project,
  store,
}) => {
  const lowercaseFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toLowerCase() + str.slice(1);
  };

  return (
    <Paper
      elevation={2}
      sx={{ padding: "0 16px", borderRadius: 2, width: "58rem" }}
    >
      <Accordion sx={{ boxShadow: "none", width: "auto" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel-content"
          id="panel-header"
          sx={{ minHeight: "48px", padding: "0 16px" }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body1">Last updated by</Typography>
              <ColoredAvatar name={name || "Devops"} size={20} />
              <Typography variant="body1">
                <strong>{name || "Devops"}</strong> {timeAgo || "some time ago"}
              </Typography>
            </Box>
            <Typography sx={{ color: "#1976d2" }}>Secret Details</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            borderTop: "1px solid #ddd",
            pt: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Grid container spacing={1} maxWidth={400}>
            {[
              ["Cluster name", clusterName],
              ["Created by", createdBy || "Devops"],
              ["Secret name", secretName],
              ["Environment", env],
              ["Team", project],
              ["Store name", store === "test" ? "AWS Secret Manager" : store],
            ].map(([label, value], index) => (
              <Grid item xs={12} key={index} container>
                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", fontSize: ".9rem" }}>
                    {label}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ width: "20rem", fontSize: ".9rem" }}>
                    {value || "N/A"}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
};

export default SecretDetailsCard;
